<template>
  <div :class="['md-layout spacing', mainClass]">
    <label :class="['md-layout-item md-size-25 md-form-label', labelClass]">
      {{ label }}
    </label>

    <div class="md-layout-item" :class="fieldClass">
      <v-select
          v-bind="$attrs"
          v-on="listeners"
          :value="value"
          :options="options"
          :label="name"
          :reduce="returnObject ? option => option : option => option[trackBy]"
          :taggable="taggable"
          :multiple="multiple"
          :append-to-body="true"
          @input="$emit('input', $event)"
          @new-option="addTag"
          class="vselect-full"
          @option:selecting="onSelecting"
          @option:deselecting="onRemove"
          @option:deselected="onRemoving"
          @search="search"
      >
        <!-- Pass named slots -->
        <template v-for="(slotFn, name) in $slots" v-slot:[name]>
          <slot :name="name" />
        </template>

        <!-- Pass scoped slots -->
        <template v-for="(slotFn, name) in $scopedSlots" v-slot:[name]="scope">
          <slot :name="name" v-bind="scope" />
        </template>
      </v-select>

      <validation-error :errors="error" />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ValidationError from '../ValidationError';

export default {
    name: 'SelectInputHorizontal',
    components: {
        vSelect,
        ValidationError,
    },
    props: {
        value: [Number, String, Array, Object],
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
        trackBy: {
            type: String,
            default: 'id',
        },
        name: {
            type: String,
            default: 'name',
        },
        error: {
            type: Array,
            default: () => [],
        },
        taggable: {
            type: Boolean,
            default: false,
        },
        mainClass: {
            type: String,
            default: '',
        },
        fieldClass: {
            type: String,
            default: '',
        },
        labelClass: {
            type: String,
            default: '',
        },
      multiple: {
        type: Boolean,
        default: false
      },
      returnObject: {
        type: Boolean,
        default: false
      },
    },
    computed: {
        listeners () {
            return {
                ...this.$listeners,
            };
        },
    },
    methods: {
        addTag (newTag) {
            const tagObj = {
                [this.trackBy]: newTag,
                [this.name]: newTag,
            };
            this.$emit('input', tagObj[this.trackBy]);
        },
        onSelecting (option, index) {
            this.$emit('selecting', option, index);
        },
        onRemove (option) {
            this.$emit('remove', option);
        },
        onRemoving (option) {
            this.$emit('removing', option);
        },
        search (searchValue, loading) {
            this.$emit('search', searchValue, loading);
        }
    },
};
</script>

<style scoped>
.vselect-full {
  width: 100%;
  z-index: 9999;
}

.vs__dropdown-menu {
  z-index: 9999 !important;
}
</style>
